import { Box, Button, IconButton, Stack, Typography } from '@mui/material';

import Iconify from '../../components/Iconify';
import PropTypes from 'prop-types';
import React from 'react';
import { fCurrency } from '../../utils/formatNumber';

function EventCheckoutResume({
  resume: { total, currency },
  onArrowClick,
  onBuyClick = () => {},
  btnLabel = '',
  btnDisabled = false,
  btnIcon = false,
}) {
  return (
    <Stack direction="row" sx={{ width: '100%' }}>
      <Box sx={{ minWidth: 160 }}>
        <Stack direction="row" sx={{ width: '100%' }}>
          <Typography
            variant="subtitle1"
            sx={{
              lineHeight: '30px',
            }}
          >{`${fCurrency(total)} ${currency}`}</Typography>
          {onArrowClick && (
            <IconButton onClick={onArrowClick}>
              <Iconify
                width={14}
                height={14}
                icon={'material-symbols:keyboard-arrow-up'}
              />
            </IconButton>
          )}
        </Stack>
        <Stack direction="column" sx={{ color: 'text.secondary' }}>
          <Typography variant="caption" sx={{ fontWeight: 400 }}>
            Total a pagar
          </Typography>
        </Stack>
      </Box>
      <Box sx={{ flexGrow: 1 }}></Box>
      <Button
        startIcon={
          btnIcon ? (
            <Iconify width={24} height={24} icon="ph:lock-key-light" />
          ) : null
        }
        variant="contained"
        sx={{ minWidth: 145 }}
        onClick={onBuyClick}
        disabled={btnDisabled}
      >
        {btnLabel}
      </Button>
    </Stack>
  );
}

EventCheckoutResume.propTypes = {
  resume: PropTypes.object.isRequired,
  onArrowClick: PropTypes.func,
  onBuyClick: PropTypes.func,
  btnLabel: PropTypes.string,
  btnDisabled: PropTypes.bool,
};

export default EventCheckoutResume;
